<style lang="scss" scope>
.ivu-tabs .ivu-tabs-tabpane {
  flex-shrink: 0;
  width: 100%;
  transition: opacity 0.3s;
  opacity: 1;
  outline: none;
}
.ivu-modal-wrap * {
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.ivu-pb,
.ivu-pb-16 {
  padding-bottom: 16px !important;
}
.row[data-v-75eea3a4] {
  display: flex;
  border-bottom: 1px dashed #dee5e7;
  padding: 10px;
}
.row .col[data-v-75eea3a4] {
  width: 0;
  flex: 1;
  display: flex;
  padding: 0 15px;
}
.row .col .label[data-v-75eea3a4] {
  padding: 0 15px;
  flex-shrink: 0;
  width: 100px;
}
.row .col > div[data-v-75eea3a4] {
  padding: 14px 15px;
  font-weight: 700;

  .cell {
    text-align: center;
  }
}
.flex-center{
  align-items: center;
  p{
    min-width:70px;
  }
}
.label{
  margin-right: 16px;
}
.el-col-12{
  padding:5px;
  // border-bottom: 1px dashed #dedede;
}
.el-select{
  width:100%;
  input{
  width:100%;
}
} 
</style>
<template>
   <div class="l-edit-dialog-box" style="padding-top:15px">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="基本信息" name="first">
        <div class="ivu-tabs-tabpane" style="visibility: visible;">
          <div data-v-75eea3a4="" class="ivu-pb">
            <el-form :model="form_data" label-width="80px" class="jt-v-form" ref="form" label-position="left" v-loading="loading">
            <el-row>
              <el-col :span="12">
                <el-form-item label="场所名称" prop="name">
                  <el-input placeholder="请输入场所名称" v-model="form_data.name" class="input-with-select" style="width: 100%;">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="楼层数" prop="floor">
                <el-input type="number" placeholder="请输入楼层数" v-model="form_data.floor" class="input-with-select" style="width: 100%;">
                </el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="12">
                <el-form-item label="楼栋户数" prop="doorplate_name">
                  <el-input type="number" placeholder="请输入楼栋户数" v-model="form_data.doorplate_name" class="input-with-select" style="width: 100%;">
                  </el-input>
                </el-form-item>
              </el-col> -->
              <el-col :span="12">
                <el-form-item label="所属社区" prop="community_id">
                  <el-select v-model="form_data.community_id" placeholder="全部" clearable>
                    <el-option v-for="item in community_list" style="width:50%" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
                </el-form-item> 
              </el-col>
              <el-col :span="12">
                <el-form-item label="所属街道" prop="street_id">
                  <el-select v-model="form_data.street_id" placeholder="全部" clearable>
                    <el-option v-for="item in street_list" style="width:50%" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
                </el-form-item> 
              </el-col>
              
              <el-col :span="12">
                <el-form-item label="场所状态" prop="state">
                  <el-select v-model="form_data.state" placeholder="全部" clearable>
              <el-option v-for="item in community_list" style="width:50%" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
                </el-form-item>
                
              </el-col>
              <el-col :span="12">
                <el-form-item label="所属网格" prop="network">
                  <el-input placeholder="请输入" v-model="form_data.network" class="input-with-select" style="width: 100%;">
                </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="详细地址" prop="address">
                  <el-input placeholder="请输入" v-model="form_data.address" class="input-with-select" style="width: 100%;">
                </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="地址编码" prop="address_code">
                  <el-input placeholder="请输入" v-model="form_data.address_code" class="input-with-select" style="width: 100%;">
                </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="门牌地址" prop="doorplate_address">
                  <el-input placeholder="请输入" v-model="form_data.doorplate_address" class="input-with-select" style="width: 100%;">
                </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="楼栋编码" prop="building_code">
                  <el-input placeholder="请输入" v-model="form_data.building_code" class="input-with-select" style="width: 100%;">
                </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="门牌名称" prop="doorplate_name">
                  <el-input placeholder="请输入" v-model="form_data.doorplate_name" class="input-with-select" style="width: 100%;">
                </el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="12">
                <el-form-item label="单位人数" prop="name">
                  <el-input type="number" placeholder="请输入单位人数" v-model="form_data.staff_number" class="input-with-select" style="width: 100%;">
                </el-input>
                </el-form-item>
              </el-col> -->
              <el-col :span="12">
                <el-form-item label="负责人" prop="charge">
                  <el-input placeholder="请输入负责人" v-model="form_data.charge" class="input-with-select" style="width: 100%;">
                </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系电话" prop="iphone">
                  <el-input placeholder="请输入联系电话" v-model="form_data.iphone" class="input-with-select" style="width: 100%;">
                </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            </el-form>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="照片" name="second">
        <div class="ivu-tabs-tabpane" style="visibility: visible;">
          <div data-v-75eea3a4="" class="ivu-pb">
            <el-form :model="form_data" label-width="120px" class="jt-v-form" ref="form" label-position="top" v-loading="loading">
              <el-row>
                <el-col :span="8" v-for="(item,index) in photo_name_list" :key="index">
                  <el-form-item :label="state_name(item.value)" prop="photo_selfie">
                    <l-upload-img method="place_photoUpload" accept=".jpg,.png,.bmp" name="img" :on-success="(res)=>handleUploadSuccess(res,item.value)" :preview-url="material[item.value].length>0?material[item.value]:''">
                    </l-upload-img>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
    </div>

    

  </div>

</template>

<script>
import {
        types,
        getName
    } from './pic.js';


export default {
  name: 'l-place-edit',
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    visible: {
      type: Boolean,
    },
  },

  components: {
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          // console.log(navigator.geolocation)
          this.getData();
          

        }
      }
    }
  },
  
  data() {
    return {
      loading: false,//页面是否加载中
      //表单数据
      form_data: {
      },
      photo_name_list: types,
      facade_photo: "",
      danger_notification_photo: "",
      signature_photo: "",
      sign_for_photo: "",
      work_photo: "",
      activeName: 'first',
      info_data: {},

      info_visible:false,
      info_name:"",
      photo_selfie_preview: "",
      submitting:false,
      community_list:[],
      street_list:[],
      material:[]
    }
  },
  methods: {
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit('update:visible', false);
    },
    handleClick() {

    },

    //获取数据
    getData() {
      //获取搜索信息 
      this.$_invoke("place_getSearchData", {
      })
        .then((ret) => {
          this.street_list = ret.street_list;
          this.community_list = ret.community_list;
          this.place_type_list = ret.place_type_list;
        })
        .finally(() => {
          this.loading = false;
        });
      if (this.hasId) {
        // console.log('hjsagdfa')
        this.loading = true;
        this.$_invoke(`place_placeData`, { id: this.$props.id }).then((ret) => {
          this.form_data = ret.data;
          this.material = ret.material;
          

        }).finally(() => {
          this.loading = false;
        });

      }
    },
    //上传图标成功后的回调
    handleUploadSuccess(res, field) {
      this.form_data[field]=[res.data.photo];
      this[field + "_preview"] = res.data.photo;
      // console.log(res.data)
      this.$_invoke("place_photoUploadSave",{
        place_id:this.id,
        field:field,
        photo:[res.data.photo]
      }).then(()=>{
          this.$_msg.success('修改成功');
      })
    },
    inspectInfo() {
      // // console.log(row);
    },
    handleSubmit(){
      // console.log(this.hiddenList);
      this.submitting = true;
      this.$_invoke('place_placeUpdate',{
        id:this.id,
        ...this.form_data
      }).then(() => {
        this.$_msg.success('修改成功');
        this.$emit('on-success');
      }).finally(() => {
        this.submitting = false;
      })
    },
    state_name(state) {
                return getName(state)
            },

  },
}
</script>